module.exports = __webpack_public_path__ + "img/pexels-photo-3927387.e26ce125.jpeg";